import axios from '@api'

export default {
  getTestItem () {
    return axios.get('api/test/gettestitem')
  },
  getTestItemList () {
    return axios.get('api/test/gettestitemlist')
  }
}